import { ActivatedRoute, CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { APP_PAGE_PATH } from '@app/consts';

export const appRedirectGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);

  return settingsService.getSettingsOnce()
    .pipe(
      map(settings => {
        if (!settings.hasOnlyAppWithoutWebforms()) {
          return true;
        }
        return router.createUrlTree(['.', APP_PAGE_PATH], { relativeTo: activatedRoute });
      }),
    );
};
